import * as yup from "yup"
import { InValidInputNotAllowSymbols, InvalidTypeDate, mustBeInput } from "./_template";

export const MenuSchema = yup.object({
  target_month: yup.date().required(mustBeInput).typeError(InvalidTypeDate),
  name: yup.string().required(mustBeInput).matches(/^[^\-+=^$*.\[\]{}()?\"!@#%&\/\\\\,><\':;|_~`\-+=]*$/, InValidInputNotAllowSymbols).max(30, '30文字未満で入力してください'),
  preset_conditions_id: yup.string().required(mustBeInput),
});